import React from 'react';
import './InvitationSection.css';
import urls from '../config/urls';

const InvitationSection = () => {
  const invitationLink = urls.invitation;

  return (
    <section id="invitation" className="invitation-section">
      <div className="container">
        <div className="invitation-content">
          <div className="invitation-header">
            <div className="section-badge">
              <span className="badge-icon">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M8 1l1.5 3h3.5l-2.5 2 1 3L8 7l-3 2 1-3L3.5 4h3.5L8 1z" fill="currentColor"/>
                </svg>
              </span>
              Únete a la Revolución
            </div>
            <h2 className="section-title">
              ¡Transforma el <span className="gradient-text">Futuro de la Medicina</span>!
            </h2>
            <p className="section-subtitle">
              Llamado a los médicos del futuro: ThinkHealth y Grehta.org te invitan a ser pionero 
              en la transformación digital de la salud e integrar la inteligencia artificial en tu práctica.
            </p>
          </div>

          <div className="invitation-features">
            <div className="feature-row">
              <div className="feature-item">
                <div className="feature-icon">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M16 2C8.3 2 2 8.3 2 16s6.3 14 14 14 14-6.3 14-14S23.7 2 16 2z" stroke="currentColor" strokeWidth="2" fill="none"/>
                    <path d="M8 16l6 6 10-10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="feature-content">
                  <h3>Comunidad Innovadora</h3>
                  <p>Forma parte de una red de profesionales que está modelando el futuro de la atención médica</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M16 6a10 10 0 1 0 0 20 10 10 0 0 0 0-20z" stroke="currentColor" strokeWidth="2" fill="none"/>
                    <path d="M16 10v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="feature-content">
                  <h3>Herramientas Avanzadas</h3>
                  <p>Acceso a diagnósticos asistidos por IA y tecnología de vanguardia en cardiología</p>
                </div>
              </div>
            </div>

            <div className="feature-row">
              <div className="feature-item">
                <div className="feature-icon">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="currentColor" strokeWidth="2" fill="none"/>
                  </svg>
                </div>
                <div className="feature-content">
                  <h3>Colaboración Experta</h3>
                  <p>Oportunidad de trabajar con líderes en cardiología y especialistas reconocidos</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M16 2L4 8v10c0 7.5 5.2 14.3 12 16 6.8-1.7 12-8.5 12-16V8L16 2z" stroke="currentColor" strokeWidth="2" fill="none"/>
                    <path d="M12 16l3 3 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="feature-content">
                  <h3>Excelencia Médica</h3>
                  <p>Comprometidos con los más altos estándares de calidad y innovación en salud</p>
                </div>
              </div>
            </div>
          </div>

          <div className="invitation-cta">
            <div className="cta-message">
              <p>
                Si eres un profesional de la salud comprometido con la excelencia y la innovación,
                <strong> este es tu momento.</strong>
              </p>
            </div>
            
            <a href={invitationLink} target="_blank" rel="noopener noreferrer" className="glass-button primary">
              <span className="btn-glow"></span>
              <span className="btn-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M22 12h-4l-3 9L9 3l-3 9H2" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              Regístrate Aquí y Transforma el Futuro
              <span className="btn-arrow">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M5 10l5 5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            </a>

            <div className="cta-note">
              <p>
                Únete a más de 500+ profesionales que ya confían en ThinkHealth
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvitationSection;
